module.exports = __webpack_public_path__ + "static/vast_oasis-74f845463c4817f0223c6a5e68a578c1.webp";